import { getReferralCode, trackReferralLead } from "@/utils/referral";

export const WHATSAPP_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER || "5212713939941";

export const CATEGORY_LABELS = {
  hombre: "Hombre",
  mujer: "Mujer",
  gorras: "Gorras",
  accesorios: "Accesorios",
  zapatos: "Zapatos",
  ninos: "Ninos",
  nuevos: "Nuevos",
  ofertas: "Liquidacion",
};

export function getProductSizes(product) {
  if (product.available_sizes?.length > 0) return product.available_sizes;
  return product.size?.split(",").map(s => s.trim()).filter(Boolean) || [];
}

export function buildProductMessage(product, { imageUrl, selectedSize } = {}) {
  const sizes = getProductSizes(product);
  const lines = ["Hola! Me interesa este producto:", "", `Producto: ${product.name}`];
  if (product.brand) lines.push(`Marca: ${product.brand}`);
  if (product.category) lines.push(`Categoria: ${CATEGORY_LABELS[product.category] || product.category}`);
  if (selectedSize) lines.push(`Talla: ${selectedSize}`);
  else if (sizes.length) lines.push(`Tallas disponibles: ${sizes.join(", ")}`);
  let price = `Precio: $${Number(product.sale_price || 0).toFixed(0)} MXN`;
  if (product.retail_price > product.sale_price) price += ` (antes $${Number(product.retail_price).toFixed(0)})`;
  lines.push(price);
  if (product.exclusive) lines.push("Producto exclusivo");
  if (imageUrl) lines.push(`Foto: ${imageUrl}`);
  const ref = getReferralCode();
  if (ref) lines.push("", `Referido por: ${ref}`);
  return lines.join("\n");
}

export function openWhatsApp(message) {
  trackReferralLead();
  window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`, "_blank");
}
